/* KBM UGC Extra - Adds product-specific TikTok/Instagram embeds for products not in the Liquid mapping */
(function(){
  if (!document.body.classList.contains('template-product')) return;

  /* Per-product UGC map: handle/title pattern → {ig: [reel codes], tt: [video ids]} */
  var UGC_MAP = [
    {
      match: function(title, handle){ return /hickory/i.test(title) || /hickory/i.test(handle); },
      ig: ['DYQZTJjD7Gy', 'DVEuCl8kuWW'],
      tt: ['7616913682336877855', '7610142637852560653']
    },
    {
      match: function(title, handle){
        var t = title.toLowerCase(), h = handle.toLowerCase();
        return (/herringbone/.test(t) && /(twill|cotton)/.test(t)) ||
               (/herringbone/.test(h) && /(twill|cotton)/.test(h));
      },
      ig: [],
      tt: ['7636218662076108046', '7622104079803698446']
    }
  ];

  function getProductInfo(){
    var titleEl = document.querySelector('.product-info h1');
    var title = titleEl ? titleEl.textContent.trim() : '';
    var handle = (location.pathname.match(/\/products\/([^\/\?#]+)/) || [])[1] || '';
    return { title: title, handle: handle };
  }

  function matchedEmbeds(){
    var info = getProductInfo();
    var ig = [], tt = [];
    UGC_MAP.forEach(function(entry){
      if (entry.match(info.title, info.handle)) {
        ig = ig.concat(entry.ig || []);
        tt = tt.concat(entry.tt || []);
      }
    });
    return { ig: ig, tt: tt };
  }

  function buildCard(html, isTikTok){
    var card = document.createElement('div');
    card.className = 'kbm-ugc-card' + (isTikTok ? ' kbm-ugc-card--tt' : '');
    card.innerHTML = html;
    return card;
  }

  function ensureUgcSection(){
    var existing = document.querySelector('.kbm-ugc-reviews');
    if (existing) return existing.querySelector('.kbm-ugc-reviews__grid');

    var wrap = document.createElement('div');
    wrap.className = 'kbm-ugc-reviews';
    wrap.innerHTML = '<div class="kbm-ugc-reviews__inner">' +
      '<h2 class="kbm-ugc-reviews__title">See what people made with our fabric</h2>' +
      '<p class="kbm-ugc-reviews__sub">Real customers, real garments, real projects.</p>' +
      '<div class="kbm-ugc-reviews__grid"></div>' +
      '</div>';
    var anchor = document.querySelector('.kbm-ugc-submit') || document.querySelector('.related-products') || document.querySelector('.kbm-recently-viewed');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wrap, anchor);
    else document.body.appendChild(wrap);
    return wrap.querySelector('.kbm-ugc-reviews__grid');
  }

  function inject(){
    var embeds = matchedEmbeds();
    if (!embeds.ig.length && !embeds.tt.length) return;
    var grid = ensureUgcSection();
    if (!grid) return;

    var existingHtml = grid.innerHTML;
    embeds.ig.forEach(function(code){
      if (existingHtml.indexOf('/p/' + code + '/') !== -1 || existingHtml.indexOf('/reel/' + code + '/') !== -1) return;
      grid.appendChild(buildCard('<iframe src="https://www.instagram.com/p/' + code + '/embed/" allow="encrypted-media" allowfullscreen loading="lazy"></iframe>', false));
    });
    embeds.tt.forEach(function(id){
      if (existingHtml.indexOf('/embed/v2/' + id) !== -1) return;
      grid.appendChild(buildCard('<iframe src="https://www.tiktok.com/embed/v2/' + id + '" allow="encrypted-media" allowfullscreen loading="lazy"></iframe>', true));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject);
  else setTimeout(inject, 100);
})();
